<template>
  <div
    class="content"
  >
    <div class="backtop">
      <xs-header
        :isPc="isPc"
        @goLocation="goLocation"
        :isOpenParm="isOpen"
        :key="isOpen"
        :previewPage="previewPage"
        @typeLanguageFunc="typeLanguageFunc"
      ></xs-header>
      <h2 style="display: none">{{ meetingSubject }}</h2>
      <h2 style="display: none">{{ meetingSubjectEn }}</h2>
      <div class="out">
        <!--    轮播图-->
        <carousel
          :isOpenParm="isOpen"
          :key="isOpen"
          :previewPage="previewPage"
        ></carousel>
        <!--    内容-->
        <div v-if="isPc">
          <el-row :gutter="20">
            <el-col :span="7">
              <!-- 发起单位 -->
              <div class="xs-in-box" v-if="isHide === 0">
                <div class="header">
                  <i class="el-icon-office-building"></i>
                  <span>{{ $t("front.startCompany") }}</span>
                </div>
                <div class="xs-in-box-body start-company-out">
                  <span v-if="lang == 'zh'" @click="toCompany">{{sponsor }}</span>
                  <span v-if="lang == 'en'" @click="toCompany">{{sponsorEn }}</span>
                </div>
              </div>

              <!-- 主办单位 -->
              <div class="xs-in-box" v-if="organizerIsHide === 0">
                <div class="header">
                  <i class="el-icon-office-building"></i>
                  <span>{{ $t("common.Organizer") }}</span>
                </div>
                <div class="xs-in-box-body start-company-out">
                  <span v-if="lang == 'zh'">{{organizer }}</span>
                  <span v-if="lang == 'en'">{{organizerEn }}</span>
                </div>
              </div>

              <div class="xs-in-box">
                <div class="header">
                  <i class="el-icon-date"></i>
                  <span>{{ $t("front.importantDate") }}</span>
                </div>
                <div class="xs-in-box-body">
                  <!--      时间线        -->
                  <time-line-component
                    :themeColorParam="themeColor"
                    :key="themeColor && isOpen"
                    :isOpenParm="isOpen"
                    :previewPage="previewPage"
                  ></time-line-component>
                </div>
              </div>
            </el-col>
            <!--    tab标签切换        -->
            <el-col
              :span="17"
              style="margin-top: 20px"
            >
              <div class="xs-tabs-out">
                <div class="tab-title">
                  <span
                    :class="activeName == 1 ? 'active' : ''"
                    @click="activeName = 1"
                  >{{ $t("front.meetIntroduce") }}</span>
                  <span
                    :class="activeName == 2 ? 'active' : ''"
                    @click="activeName = 2"
                    v-if="meetingSchedule || meetingScheduleEn"
                  >{{ $t("front.meetSchedule") }}</span>
                  <span
                    :class="activeName == 3 ? 'active' : ''"
                    @click="activeName = 3"
                    v-if="
                      otherConferenceInformation || otherConferenceInformationEn
                    "
                  >{{ $t("front.meetOther") }}</span>
                </div>
                <div
                  class="inner-text"
                  v-show="activeName == 1"
                >
                  <div
                    class="ql-editor"
                    v-html="conferenceIntroduction"
                    v-if="lang == 'zh'"
                  ></div>
                  <div
                    class="ql-editor"
                    v-html="conferenceIntroductionEn"
                    v-if="lang == 'en'"
                  ></div>
                </div>
                <div
                  class="inner-text"
                  v-show="activeName == 2"
                >
                  <div
                    class="ql-editor"
                    v-html="meetingSchedule"
                    v-if="lang == 'zh'"
                  ></div>
                  <div
                    class="ql-editor"
                    v-html="meetingScheduleEn"
                    v-if="lang == 'en'"
                  ></div>
                </div>
                <div
                  class="inner-text"
                  v-show="activeName == 3"
                >
                  <div
                    class="ql-editor"
                    v-html="otherConferenceInformation"
                    v-if="lang == 'zh'"
                  ></div>
                  <div
                    class="ql-editor"
                    v-html="otherConferenceInformationEn"
                    v-if="lang == 'en'"
                  ></div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <div v-if="!isPc">
          <!--  发起单位 -->
          <div class="xs-in-box quesshow1" v-if="isHide === 0">
            <div class="header">
              <i class="el-icon-office-building"></i>
              <span>{{ $t("front.startCompany") }}</span>
            </div>
            <div class="xs-in-box-body start-company-out">
              <span v-if="lang == 'zh'" @click="toCompany">{{ sponsor }}</span>
              <span v-if="lang == 'en'" @click="toCompany">{{sponsorEn }}</span>
            </div>
          </div>

          <!-- 主办单位 -->
          <div class="xs-in-box" v-if="organizerIsHide === 0">
            <div class="header">
              <i class="el-icon-office-building"></i>
              <span>{{ $t("common.Organizer") }}</span>
            </div>
            <div class="xs-in-box-body start-company-out">
              <span v-if="lang == 'zh'">{{organizer }}</span>
              <span v-if="lang == 'en'">{{organizerEn }}</span>
            </div>
          </div>

          <div class="xs-in-box quesshow2">
            <div class="header">
              <i class="el-icon-date"></i>
              <span>{{ $t("front.importantDate") }}</span>
            </div>
            <div class="xs-in-box-body">
              <!--      时间线        -->
              <time-line-component
                :themeColorParam="themeColor"
                :key="themeColor && isOpen"
                :isOpenParm="isOpen"
              ></time-line-component>
            </div>
          </div>

          <div class="xs-in-box quesshow3">
            <div class="header">
              <i class="el-icon-tickets"></i>
              <span>{{ $t("front.meetIntroduce") }}</span>
            </div>
            <div class="xs-in-box-body-pre">
              <div
                class="ql-editor"
                v-html="conferenceIntroduction"
                v-if="lang == 'zh'"
              ></div>
              <div
                class="ql-editor"
                v-html="conferenceIntroductionEn"
                v-if="lang == 'en'"
              ></div>
            </div>
          </div>

          <div
            class="xs-in-box quesshow4"
            v-if="meetingSchedule || meetingScheduleEn"
          >
            <div class="header">
              <i class="el-icon-reading"></i>
              <span>{{ $t("front.meetSchedule") }}</span>
            </div>
            <div class="xs-in-box-body-pre">
              <div
                class="ql-editor"
                v-html="meetingSchedule"
                v-if="lang == 'zh'"
              ></div>
              <div
                class="ql-editor"
                v-html="meetingScheduleEn"
                v-if="lang == 'en'"
              ></div>
            </div>
          </div>

          <div
            class="xs-in-box quesshow5"
            v-if="otherConferenceInformation || otherConferenceInformationEn"
          >
            <div class="header">
              <i class="el-icon-document"></i>
              <span>{{ $t("front.meetOther") }}</span>
            </div>
            <div class="xs-in-box-body-pre">
              <div
                class="ql-editor"
                v-html="otherConferenceInformation"
                v-if="lang == 'zh'"
              ></div>
              <div
                class="ql-editor"
                v-html="otherConferenceInformationEn"
                v-if="lang == 'en'"
              ></div>
            </div>
          </div>
        </div>
        <!--        <div class="index-wrap">-->
        <!--          index{{ $t('common.home') }}-->
        <!--        </div>-->
      </div>

      <!--      <div style="width:200px;height: 200px;" class="colortest" @click="handleClick"></div>-->
      <xs-footer></xs-footer>
    </div>
    <el-backtop target=".backtop"></el-backtop>
  </div>
</template>
<script>
import xsHeader from "@/components/index/xsHeader";
import Carousel from "@/components/index/Carousel";
import xsFooter from "@/components/index/xsFooter";
import timeLineComponent from "@/components/index/timeLineComponent";
import mixin from "@/mixins";
import utils from "@/utils/utils";
export default {
  name: "search",
  data() {
    return {
      id: "",
      isPc: "",
      activeName: "1",
      themeColor: "#4288EA",
      title: "",

      showIndex: 1, //滚动

      //会议介绍
      conferenceIntroduction: "",
      conferenceIntroductionEn: "",
      meetingSchedule: "",
      meetingScheduleEn: "",
      otherConferenceInformation: "",
      otherConferenceInformationEn: "",
      //发起单位
      sponsor: "",
      sponsorEn: "",
      isHide: "",
      meetingSubject: "",
      meetingSubjectEn: "",
      organizer: "",
      organizerEn: "",
      organizerIsHide: "",
      isOpen: false,
      previewPage: false,

      lang: "zh",
      // 会议code对应会议简称
      // meetingCodeList: {
      //   M1638557100068442112: "CFTRC2023",
      //   M1478929126508597248: "CFTRC2022",
      //   M1455733754860802048: "ACDE2022",
      //   M1526076595335729152:"ICFT2022"
      // },
    };
  },
  mixins: [mixin],
  computed: {
    // lang(){
    //   return this.$store.state.dict.lang;
    // }
  },
  watch: {},
  components: {
    xsHeader,
    Carousel,
    xsFooter,
    timeLineComponent,
  },
  mounted() {
    this.meetingCode = this.$route.params.meetingCode;
    if (this.previewPage) {
      this.getThemeColor();
      this.requestIntroduction();
      this.searchSponsor();
    } else {
      this.requesetIsOpen();
    }
    const data = {
      meetingCode: this.$route.params.meetingCode,
    };
    this.$api.getMeetingDetail(data).then((res) => {
      if (res.code == 200) {
        this.meetingSubject = res.data.meetingSubject;
        this.meetingSubjectEn = res.data.meetingSubjectEn;
        this.organizer = res.data.organizer;
        this.organizerEn = res.data.organizerEn;
        this.organizerIsHide = res.data.organizerIsHide;
      }
    });
  },
  created() {
    this.isPc = utils.isPc();
    this.previewPage =
      localStorage.getItem("previewPage") == "true" ? true : false;
  },
  methods: {
    typeLanguageFunc(val) {
      this.lang = val;
    },
    goLocation(num) {
      //跳转定位
      let el = document.getElementsByClassName(`quesshow${num}`)[0];
      el.scrollIntoView();
    },
    handleClick(tab, event) {
      console.log(tab, event);
      this.cutColor();
    },
    //设置主题色
    cutColor() {
      document
        .getElementsByTagName("body")[0]
        .style.setProperty("--test", this.themeColor);
    },
    /**
     * 请求相关
     * */
    //会议介绍
    requestIntroduction() {
      let data = {
        meetingCode: this.meetingCode,
      };
      //会议介绍
      this.$api.requestIntroduction(data).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.conferenceIntroduction = res.data.conferenceIntroduction;
            this.conferenceIntroductionEn = res.data.conferenceIntroductionEn;
          }
        }
      });

      //会议日程
      this.$api.searchSchedule(data).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.meetingSchedule = res.data.meetingSchedule;
            this.meetingScheduleEn = res.data.meetingScheduleEn;
          }
        }
      });

      //其他信息
      this.$api.searchOther(data).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.otherConferenceInformation =
              res.data.otherConferenceInformation;
            this.otherConferenceInformationEn =
              res.data.otherConferenceInformationEn;
          }
        }
      });
    },
    //请求发起单位
    searchSponsor() {
      let data = {
        meetingCode: this.meetingCode,
      };
      this.$api.searchSponsor(data).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.sponsor = res.data.sponsor;
            this.sponsorEn = res.data.sponsorEn;
            this.hyperlinks = res.data.hyperlinks;
            this.isHide = res.data.isHide;
          }
        }
      });
    },
    toCompany() {
      if (this.hyperlinks) {
        window.open(this.hyperlinks, "_blank");
      }
    },
    //请求是否公开
    requesetIsOpen() {
      let data = {
        meetingCode: this.meetingCode,
      };
      this.$api.searchIsItOpen(data).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            let isOpen = res.data.isItOpen == "1" ? true : false; //1公开，0不公开
            this.isOpen = isOpen;
            if (isOpen) {
              this.getThemeColor();
              this.requestIntroduction();
              this.searchSponsor();
            } else {
              this.$message.error("未公开");
            }
          }
        }
      });
    },
    getThemeColor() {
      let data = {
        meetingCode: this.meetingCode,
      };
      this.$api.requestThemeMessage(data).then((res) => {
        if (res.code == 200) {
          this.themeColor = res.data.themeColorType;
          this.cutColor();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.colortest {
  background: $themeColor;
}
.content {
  height: 100%;
}
.backtop {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100%;
}
/* pc端样式 */
@media screen and (min-width: 900px) {
  .out {
    width: 960px;
    margin: 0 auto;
    .xs-in-box {
      margin-top: 20px;
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.14);
      .header {
        display: flex;
        justify-content: left;
        align-items: center;
        height: 50px;
        color: #fff;
        font-size: 16px;
        background: $themeColor;
        i {
          background: #fff;
          width: 26px;
          height: 26px;
          border-radius: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 10px;
          color: $themeColor;
        }
        span {
          margin-left: 10px;
        }
      }
      .xs-in-box-body {
        min-height: 100px;
        display: flex;
        justify-content: left;
        align-items: center;
        padding: 10px;
        span {
          color: #333333;
          font-size: 14px;
        }
      }
      .start-company-out {
        span {
          white-space: pre-wrap;
          cursor: pointer;
        }
      }
    }
  }

  .xs-tabs-out {
    min-height: 200px;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.14);
    .tab-title {
      display: flex;
      justify-content: left;
      align-items: center;
      height: 50px;
      color: #fff;
      font-size: 16px;
      background: $themeColor;
      span {
        margin-left: 10px;
        margin: 5px 5px 0 5px;
        cursor: pointer;
        height: 45px;
        line-height: 45px;
        padding: 0 5px;
        transition: all 0.2s;
      }
      span:hover {
        color: $themeColor;
        background: #fff;
      }
      .active {
        color: $themeColor;
        background: #fff;
      }
    }
    .inner-text {
      padding: 20px;
    }
  }

  .ql-editor {
    white-space: pre-wrap;
    font-size: 14px;
    line-height: 1.5;
    ::v-deep em {
      font-style: italic;
    }
    ::v-deep a {
      word-break: break-all;
    }
    ::v-deep .ql-align-center {
      text-align: center;
    }
    ::v-deep .ql-editor .ql-size-small {
      font-size: 0.75em;
    }
    ::v-deep .ql-size-large {
      font-size: 1.5em;
    }
    ::v-deep .ql-size-huge {
      font-size: 2.5em;
    }
  }
}
/* 移动端样式 */
@media screen and (max-width: 900px) {
  .out {
    width: 100%;
    max-width: 800px;
    overflow: hidden !important;
    .xs-in-box {
      margin-top: 16px;
      margin-left: 16px;
      margin-right: 16px;
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.14);
      .header {
        display: flex;
        justify-content: left;
        align-items: center;
        height: 50px;
        color: #fff;
        font-size: 16px;
        background: $themeColor;
        i {
          background: #fff;
          width: 26px;
          height: 26px;
          border-radius: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 10px;
          color: $themeColor;
        }
        span {
          margin-left: 10px;
        }
      }
      .xs-in-box-body {
        min-height: 100px;
        display: flex;
        justify-content: left;
        align-items: center;
        padding: 10px;
        span {
          white-space: pre-wrap;
          color: #333333;
          font-size: 14px;
        }
      }
      .xs-in-box-body-pre {
        padding: 10px;
      }
      .ql-editor {
        line-height: 1.5;
        font-size: 14px !important;
        white-space: pre-wrap;
        ::v-deep .ql-align-center {
          text-align: center;
        }
        ::v-deep em {
          font-style: italic;
        }
        ::v-deep a {
          word-break: break-all;
        }
        ::v-deep img {
          max-width: 100%;
        }
      }
    }
  }
}
</style>
<style>
html,
body {
  padding: 0;
  margin: 0;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
  overflow-y: auto;
  height: 100vh;
  overflow-x: hidden;
}
</style>
